import { render } from "./pop-up.vue?vue&type=template&id=45c4fddc&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-45c4fddc"

export default script